/** Tiny deterministic PRNG — same seed ⇒ same stream. */

export function hashSeed(seed: string, salt = 0): number {
  let h = 2166136261 ^ salt;
  for (let i = 0; i < seed.length; i++) {
    h ^= seed.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

export function mulberry32(seed: number) {
  let a = seed >>> 0;
  return function rand() {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function newRunSeed(): string {
  const n = Math.floor(Math.random() * 0xffffffff)
    .toString(16)
    .padStart(8, "0");
  return `${n}${Date.now().toString(36)}`.slice(0, 16);
}

export function isRunSeed(raw: unknown): raw is string {
  return typeof raw === "string" && /^[a-z0-9]{8,24}$/i.test(raw);
}
